export enum UrlMatchTypeGq {
  EXACT = 'EXACT',
  STARTS = 'STARTS',
  CONTAINS = 'CONTAINS',
}